import projects from '../data/projects';
import { getContactMessages, getWhatsAppUrl } from '../config/contact';
import { useI18n } from '../i18n';
import SpotlightSurface from './SpotlightSurface';
import './Portfolio.css';

const Portfolio = () => {
  const { locale, t } = useI18n();
  const localizedProjects = locale === 'en'
    ? projects.map((project) => ({ ...project, ...t.projectText[project.id] }))
    : projects;
  const messages = getContactMessages(locale);
  return (
  <section id="portfolio" className="portfolio" tabIndex={-1} aria-labelledby="portfolio-title">
    <div className="container">
      <div className="portfolio-heading">
        <div>
          <p className="eyebrow">{t.portfolio.eyebrow}</p>
          <h2 id="portfolio-title">{t.portfolio.title}</h2>
        </div>
        <p>{t.portfolio.intro}</p>
      </div>
      <div className="portfolio-grid">
        {localizedProjects.map((project, index) => (
          <article
            className={`portfolio-card${project.featured ? ' portfolio-card--featured' : index < 3 ? ' portfolio-card--medium' : ''}`}
            key={project.id}
            aria-labelledby={`project-${project.id}`}
          >
            <div className="portfolio-media">
              {project.image ? (
                <>
                  <img src={project.image} alt={project.imageAlt} loading="lazy" decoding="async" width="1280" height="800" />
                  <span className="portfolio-media-caption">{project.imageCaption}</span>
                </>
              ) : (
                <div className="portfolio-media-placeholder">
                  <span className="portfolio-media-wordmark" aria-hidden="true">{project.name}</span>
                  <span className="portfolio-media-note">{t.portfolio.imagePlaceholder}</span>
                </div>
              )}
            </div>
            <div className="portfolio-card-body">
              <div className="portfolio-card-meta">
                <span>{project.category}</span>
                <span aria-hidden="true">{String(index + 1).padStart(2, '0')} / {String(localizedProjects.length).padStart(2, '0')}</span>
              </div>
              <h3 id={`project-${project.id}`}>{project.name}</h3>
              <p className="portfolio-project-kind">
                {t.portfolio.kinds[project.kind]}{project.stage && <span> · {project.stage}</span>}
              </p>
              <p className="portfolio-description">{project.description}</p>
              <div className="portfolio-story">
                <p><span>{t.portfolio.challenge}</span>{project.problem}</p>
                <p><span>{t.portfolio.importance}</span>{project.value}</p>
              </div>
              <ul className="portfolio-capabilities" aria-label={`${t.portfolio.capabilitiesLabel} ${project.name}`}>
                {project.capabilities.map((capability) => <li key={capability}>{capability}</li>)}
              </ul>
              <p className="portfolio-technologies">{project.technologies.join(' · ')}</p>
              {(project.demoUrl || project.repositoryUrl) && (
                <div className="portfolio-actions">
                  {project.demoUrl && <a className="section-link" href={project.demoUrl} target="_blank" rel="noopener noreferrer" aria-label={`${t.portfolio.demoAria} ${project.name} (${t.portfolio.newTab})`}>{t.portfolio.demoLink} <span aria-hidden="true">↗</span></a>}
                  {project.repositoryUrl && <a className="section-link" href={project.repositoryUrl} target="_blank" rel="noopener noreferrer" aria-label={`${t.portfolio.repositoryAria} ${project.name} (${t.portfolio.newTab})`}>{t.portfolio.repositoryLink} <span aria-hidden="true">↗</span></a>}
                </div>
              )}
            </div>
          </article>
        ))}
      </div>
      <SpotlightSurface className="cta-inline portfolio-contact" id="cta-portfolio">
        <div className="portfolio-contact-copy">
          <p className="eyebrow">{t.portfolio.contactEyebrow}</p>
          <h3>{t.portfolio.contactTitle}</h3>
          <p>{t.portfolio.contactDescription}</p>
        </div>
        <a
          className="btn-primary"
          href={getWhatsAppUrl(messages.portfolio)}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t.portfolio.contactCta} <span aria-hidden="true">↗</span>
        </a>
      </SpotlightSurface>
    </div>
  </section>
  );
};

export default Portfolio;
